import React from 'react';
import dental1 from '../assets/images/dentalHero3.jpg'

const GetTreatedToday = () => {
  return (
    <div className="py-16 bg-neutral/30">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Image on the left */}
          <div className="md:w-1/2 relative">
            <div className="rounded-lg overflow-hidden">
              <img 
                src={dental1} 
                alt="Same day dental treatment" 
                className="w-full h-auto"
              />
              <div className="absolute -bottom-4 -right-4 h-24 w-24 rounded-full bg-accent/20 z-0"></div>
            </div>
          </div>
          
          {/* Text on the right */}
          <div className="md:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold font-heading mb-6">
              Same Day Dental Treatment For a Fixed Fee
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              We have a fair and transparent pricing structure for same day emergency dental treatments. Unlike other companies, we don't charge a fortune to treat urgent problems.
            </p>
            
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="h-6 w-6 text-accent mr-2 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-lg text-gray-700">We specialise in rapid treatment of painful problems</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-accent mr-2 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-lg text-gray-700">Our dentists are fully accredited with extensive experience</span>
              </li>
              <li className="flex items-start">
                <svg className="h-6 w-6 text-accent mr-2 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-lg text-gray-700">Immediate support to discuss your treatment with no obligation</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetTreatedToday;
